export const MICRO_APP_SANDBOX_CSP = [
  "default-src 'none'",
  'frame-src blob:',
  "script-src data: blob: 'unsafe-inline'",
  "style-src data: blob: 'unsafe-inline'",
  'img-src data: blob:',
  'media-src data: blob:',
  'font-src data: blob:',
  "object-src 'none'",
  "base-uri 'none'",
  "form-action 'none'",
  "connect-src 'none'",
].join('; ')

export function createMicroAppSandboxedHtml(
  encodedClientPrefix: string,
  clientJs: string,
): string {
  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8" />
  <meta http-equiv="Content-Security-Policy" content="${MICRO_APP_SANDBOX_CSP}">
</head>
<body>
  <script type="module" src="data:text/javascript;charset=utf-8,${encodedClientPrefix}${encodeURIComponent(clientJs)}"></script>
</body>
</html>`.trim()
}
